export const ScopedType = {
  User : 'User',
  Group : "Group",
  Team: "Team",
  EntraGroup : "EntraGroup",
  EntraUser : "EntraUser"
}

export interface ScopedInstanceMember{
    Id?:string;
    Member:string;
    AadObjectId:string;
    ScopedType:string;
}